import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deactivatePromoCode } from 'scenes/PromoCodes/sources/promoCodes';

import { deactivate } from '../queryKeyFactory';
import { errorMessageGetter } from './useErrorDifferentFormatGetter';

export const useDeactivatePromoCode = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const deactivateMutation = useMutation(deactivate(), deactivatePromoCode, {
    successMessage: () => `Promo Code Deactivated`,
    errorMessage: errorMessageGetter,
  });

  const handleAction = ({ id }) => {
    return showModal({
      title: `Deactivate Promo Code?`,
      confirmActionLabel: 'Deactivate',
    }).then(() => deactivateMutation.mutateAsync({ id }));
  };

  return [handleAction, deactivateMutation];
};
